var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPresentationPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 177,
    viewBox: "0 0 205 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.201 106.456C202.201 107.88 201.209 108.484 199.958 107.751L138.123 72.0656C136.872 71.3751 135.88 69.606 135.88 68.182V16.4019C135.88 14.9779 136.872 14.3738 138.123 15.1074L199.958 50.7925C201.209 51.5261 202.201 53.2521 202.201 54.6761V106.456Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.856 49.7138L140.022 13.9855C139.418 13.6403 138.857 13.5972 138.469 13.8129L136.613 14.8917C137.002 14.6759 137.563 14.7191 138.167 15.0643L200.001 50.7494C201.252 51.4398 202.245 53.209 202.245 54.6329V106.413C202.245 107.103 202.029 107.578 201.641 107.837L203.367 106.845C203.841 106.629 204.1 106.111 204.1 105.334V53.5542C204.1 52.1734 203.064 50.4042 201.856 49.7138Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.958 50.7925L138.123 15.0642C136.872 14.3307 135.88 14.9348 135.88 16.3587V18.8615L202.201 57.1356V54.6329C202.201 53.2521 201.209 51.4829 199.958 50.7925Z",
    fill: "#C0162E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.21 16.6176L139.979 17.6532V19.6813L138.21 18.6888V16.6176Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.662 18.6457L143.431 19.6381V21.6662L141.662 20.6737V18.6457Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.114 20.6306L146.883 21.6231V23.6943L145.114 22.6587V20.6306Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.132 34.5249L140.669 26.7579V24.2552L154.132 32.0222V34.5249Z",
    fill: "#C0162E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 67.8368L145.114 36.3372V35.0859L199.656 66.5855V67.8368Z",
    fill: "#C0162E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 70.7279L138.469 35.3879V34.1797L199.656 69.5197V70.7279Z",
    fill: "#C0162E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 73.6621L138.469 38.3222V37.0708L199.656 72.4107V73.6621Z",
    fill: "#C0162E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 76.5532L138.469 41.2132V40.005L199.656 75.345V76.5532Z",
    fill: "#C0162E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 79.4874L138.469 44.1474V42.8961L199.656 78.236V79.4874Z",
    fill: "#C0162E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 82.3784L138.469 47.0385V45.8303L199.656 81.1702V82.3784Z",
    fill: "#C0162E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 85.3126L138.469 49.9727V48.7213L199.656 84.0613V85.3126Z",
    fill: "#C0162E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 88.2037L138.469 52.8637V51.6555L199.656 86.9955V88.2037Z",
    fill: "#C0162E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.656 91.1379L138.469 55.7979V54.5466L199.656 89.8865V91.1379Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.227 77.0709L138.469 58.689V57.4808L170.227 75.8196V77.0709Z",
    fill: "#C0162E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.559 134.242C166.559 136.011 165.308 136.745 163.755 135.839L70.2051 81.8149C68.6517 80.9087 67.4004 78.7512 67.4004 76.9821V6.43164C67.4004 4.66249 68.6517 3.92893 70.2051 4.83509L163.798 58.859C165.351 59.7652 166.603 61.9227 166.603 63.6918V134.242H166.559Z",
    fill: "#313131"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.869 57.6077L72.3197 3.58378C71.543 3.15228 70.8526 3.10913 70.3348 3.41118L68.3499 4.57623C68.8245 4.31733 69.5149 4.40363 70.2485 4.79198L163.841 58.8159C165.394 59.7221 166.646 61.8796 166.646 63.6487V134.242C166.646 135.105 166.344 135.753 165.826 136.055L167.811 134.89C168.372 134.631 168.717 133.983 168.717 133.034V62.4405C168.674 60.6714 167.423 58.5139 165.869 57.6077Z",
    fill: "#292929"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.798 131.524L70.2053 77.4999V8.0282L163.798 62.0521V131.524Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.324 173.725C98.8139 174.631 96.268 174.631 94.7578 173.725L1.16516 119.701C-0.345093 118.838 -0.345093 117.371 1.16516 116.465L64.941 79.6574C66.4513 78.7944 68.9971 78.7944 70.5074 79.6574L164.1 133.681C165.653 134.544 165.653 136.012 164.1 136.918L100.324 173.725Z",
    fill: "url(#paint1_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6369 87.2951L66.063 84.6629L68.3499 83.3253L72.9239 86.0006L70.6369 87.2951Z",
    fill: "#59595B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3176 91.7395L73.7437 89.1074L76.0306 87.7697L80.6045 90.445L78.3176 91.7395Z",
    fill: "#59595B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0414 96.184L81.4675 93.5518L83.7545 92.2573L88.3284 94.8895L86.0414 96.184Z",
    fill: "#59595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7653 100.672L89.1914 97.9963L91.4784 96.7018L96.0523 99.3339L93.7653 100.672Z",
    fill: "#59595B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.446 105.116L96.8721 102.441L99.159 101.146L103.733 103.778L101.446 105.116Z",
    fill: "#59595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.17 109.561L104.596 106.928L106.883 105.591L111.457 108.223L109.17 109.561Z",
    fill: "#59595B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M116.894 114.005L112.32 111.373L114.607 110.035L119.181 112.667L116.894 114.005Z",
    fill: "#59595B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.574 118.449L120 115.817L122.287 114.48L126.861 117.155L124.574 118.449Z",
    fill: "#59595B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.298 122.894L127.724 120.262L130.011 118.924L134.585 121.599L132.298 122.894Z",
    fill: "#59595B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.022 127.338L135.405 124.706L137.735 123.412L142.309 126.044L140.022 127.338Z",
    fill: "#59595B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.703 131.826L143.129 129.151L145.416 127.856L149.99 130.488L147.703 131.826Z",
    fill: "#59595B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.427 136.27L150.853 133.595L153.14 132.301L157.714 134.933L155.427 136.27Z",
    fill: "#59595B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5808 93.8538L58.3391 89.1073L62.913 86.4752L71.1547 91.2217L66.5808 93.8538Z",
    fill: "#59595B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3089 99.938L50.9604 93.3792L55.5344 90.7471L66.8828 97.3059L62.3089 99.938Z",
    fill: "#59595B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.735 106.195L43.2366 97.8237L47.8105 95.1915L62.3089 103.563L57.735 106.195Z",
    fill: "#59595B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1577 107.964L33.916 103.217L40.1296 99.636L48.3282 104.382L42.1577 107.964Z",
    fill: "#59595B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5063 114.523L45.2646 109.776L51.4783 106.195L59.7199 110.941L53.5063 114.523Z",
    fill: "#59595B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8548 121.082L56.6562 116.335L62.8267 112.754L71.0684 117.5L64.8548 121.082Z",
    fill: "#59595B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.035 143.692L95.7932 138.946L102.007 135.364L110.249 140.111L104.035 143.692Z",
    fill: "#59595B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M123.28 154.825L107.142 145.505L113.355 141.923L129.494 151.244L123.28 154.825Z",
    fill: "#59595B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6865 137.133L68.0046 122.894L74.1751 119.312L98.9001 133.552L92.6865 137.133Z",
    fill: "#59595B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4189 99.5497L69.6875 95.6662L74.2614 93.034L80.9928 96.9175L76.4189 99.5497Z",
    fill: "#59595B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1902 105.634L65.4587 101.75L70.0327 99.1182L76.7641 103.002L72.1902 105.634Z",
    fill: "#59595B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8319 111.761L61.0574 107.878L65.6744 105.245L72.4058 109.129L67.8319 111.761Z",
    fill: "#59595B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6704 117.457L70.939 113.573L75.5129 110.941L82.2443 114.825L77.6704 117.457Z",
    fill: "#59595B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5517 123.153L80.8203 119.269L85.3942 116.637L92.1256 120.521L87.5517 123.153Z",
    fill: "#59595B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3899 128.849L90.6584 124.965L95.2323 122.333L101.964 126.216L97.3899 128.849Z",
    fill: "#59595B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.271 134.544L100.54 130.661L105.114 128.029L111.845 131.912L107.271 134.544Z",
    fill: "#59595B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M117.153 140.24L110.421 136.357L114.995 133.725L121.726 137.608L117.153 140.24Z",
    fill: "#59595B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.816 149.302L120.26 142.053L124.833 139.42L137.39 146.67L132.816 149.302Z",
    fill: "#59595B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0283 111.33L75.2969 107.446L79.8708 104.814L86.6022 108.697L82.0283 111.33Z",
    fill: "#59595B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9099 117.025L85.1785 113.142L89.7524 110.51L96.4838 114.393L91.9099 117.025Z",
    fill: "#59595B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M101.791 122.721L95.0598 118.838L99.6337 116.206L106.365 120.089L101.791 122.721Z",
    fill: "#59595B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.629 128.417L104.898 124.534L109.472 121.901L116.203 125.785L111.629 128.417Z",
    fill: "#59595B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.511 134.113L114.779 130.229L119.353 127.597L126.085 131.481L121.511 134.113Z",
    fill: "#59595B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M140.324 144.987L124.618 135.925L129.235 133.293L144.898 142.311L140.324 144.987Z",
    fill: "#59595B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3003 105.245L79.5688 101.362L84.1428 98.7298L90.8742 102.613L86.3003 105.245Z",
    fill: "#59595B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1816 110.941L89.4502 107.058L94.0241 104.426L100.756 108.309L96.1816 110.941Z",
    fill: "#59595B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M106.02 116.637L99.2886 112.754L103.862 110.121L110.594 114.005L106.02 116.637Z",
    fill: "#59595B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.901 122.333L109.17 118.449L113.744 115.817L120.475 119.701L115.901 122.333Z",
    fill: "#59595B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M125.783 128.029L119.008 124.145L123.625 121.513L130.357 125.397L125.783 128.029Z",
    fill: "#59595B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 133.725L128.889 129.841L133.463 127.209L140.195 131.092L135.621 133.725Z",
    fill: "#59595B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M147.703 140.715L138.771 135.537L143.345 132.905L152.277 138.083L147.703 140.715Z",
    fill: "#59595B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.061 129.28L78.145 86.6047L80.3457 85.3102L154.305 127.986L152.061 129.28Z",
    fill: "#292929"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6864 142.657L54.9732 120.866L31.4995 134.415L69.2559 156.206L92.6864 142.657Z",
    fill: "#59595B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M164.1 136.875L100.324 173.682C99.1158 174.372 97.2604 174.545 95.7933 174.113C95.7933 174.113 94.8871 173.768 94.7577 173.682L1.16506 119.701C1.07875 119.658 0.949303 119.571 0.863002 119.528C0.819852 119.528 0.819854 119.485 0.776703 119.485C0.733553 119.442 0.690403 119.399 0.604102 119.356C0.560952 119.312 0.560953 119.312 0.517803 119.269C0.474653 119.226 0.388352 119.14 0.345202 119.097C0.345202 119.097 0.345202 119.097 0.345202 119.054C0.302052 118.967 0.258901 118.924 0.215751 118.838C0.0863002 118.622 0 118.406 0 118.147V119.485C0 120.089 0.3452 120.65 1.1219 121.125L94.7145 175.149C96.9583 176.271 100.151 176.055 101.101 175.839C102.05 175.623 102.913 175.408 103.905 175.192L164.1 140.456C164.877 140.025 165.265 139.42 165.265 138.816V135.321C165.265 135.882 164.877 136.443 164.1 136.875Z",
    fill: "#292929"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M143.517 87.5108C139.073 85.267 138.296 75.3856 133.679 73.0986C129.321 70.9411 125.998 87.5108 121.554 84.9218C117.282 82.4622 117.325 70.5528 112.967 68.0501C109.688 66.1515 109.256 71.5884 105.977 69.6898C101.878 67.3165 100.41 50.0133 96.7859 47.899C93.3339 45.914 92.7729 52.0845 90.3997 50.7037C87.0339 48.762 88.9325 37.284 84.4881 34.7382C79.9142 32.1492 80.432 43.1524 78.1019 41.7285C75.7286 40.3045 75.7718 34.695 72.104 35.2991C72.104 36.4642 72.104 72.1925 72.104 72.1925L161.899 124.059V78.2335C157.153 75.6445 147.962 89.7546 143.517 87.5108Z",
    fill: "url(#paint2_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M101.273 88.9779L102.395 89.582V61.6639L101.273 61.0598V88.9779Z",
    fill: "#59595B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M103.431 62.1817C103.431 61.1892 102.741 60.0242 101.878 59.5064C101.015 59.0317 100.324 59.4201 100.324 60.4125C100.324 61.405 101.015 62.57 101.878 63.0878C102.741 63.5625 103.431 63.1741 103.431 62.1817Z",
    fill: "#292929"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M142.957 112.926L144.078 113.53V87.8128L142.957 87.1656V112.926Z",
    fill: "#C0162E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M145.071 88.2012C145.071 87.2087 144.381 86.0437 143.518 85.5259C142.655 85.0512 141.964 85.4396 141.964 86.432C141.964 87.4245 142.655 88.5895 143.518 89.1073C144.381 89.5388 145.071 89.1505 145.071 88.2012Z",
    fill: "#59595B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7794 76.3349L72.665 75.1267V74.2637L74.7794 75.4719V76.3349Z",
    fill: "#292929"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3609 78.4061L76.2466 77.1548V76.3349L78.3609 77.5431V78.4061Z",
    fill: "#292929"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9425 80.4342L79.8281 79.226V78.4061L81.9425 79.6143V80.4342Z",
    fill: "#292929"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4806 82.5054L83.4094 81.2971V80.4341L85.4806 81.6855V82.5054Z",
    fill: "#292929"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0621 84.5766L86.9478 83.3684V82.5054L89.0621 83.7136V84.5766Z",
    fill: "#292929"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6437 86.6478L90.5293 85.4396V84.5766L92.6437 85.7848V86.6478Z",
    fill: "#292929"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2249 88.719L94.1106 87.4676V86.6478L96.2249 87.856V88.719Z",
    fill: "#292929"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8065 90.7471L97.6921 89.5389V88.719L99.8065 89.9272V90.7471Z",
    fill: "#292929"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M103.345 92.8183L101.23 91.6101V90.7471L103.345 91.9984V92.8183Z",
    fill: "#292929"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.926 94.8895L104.812 93.6812V92.8182L106.926 94.0264V94.8895Z",
    fill: "#292929"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M110.508 96.9607L108.393 95.7525V94.8895L110.508 96.0977V96.9607Z",
    fill: "#292929"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M114.089 99.0319L111.975 97.7805V96.9607L114.089 98.1689V99.0319Z",
    fill: "#292929"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M117.628 101.06L115.556 99.8517V99.0319L117.628 100.24V101.06Z",
    fill: "#292929"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M121.209 103.131L119.095 101.923V101.06L121.209 102.311V103.131Z",
    fill: "#292929"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M124.79 105.202L122.676 103.994V103.131L124.79 104.339V105.202Z",
    fill: "#292929"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M128.372 107.274L126.258 106.065V105.202L128.372 106.411V107.274Z",
    fill: "#292929"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M131.953 109.345L129.839 108.093V107.274L131.953 108.482V109.345Z",
    fill: "#292929"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M135.492 111.373L133.377 110.165V109.345L135.492 110.553V111.373Z",
    fill: "#292929"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M139.073 113.444L136.959 112.236V111.373L139.073 112.624V113.444Z",
    fill: "#292929"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M142.655 115.515L140.54 114.307V113.444L142.655 114.652V115.515Z",
    fill: "#292929"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M146.236 117.586L144.122 116.335V115.515L146.236 116.723V117.586Z",
    fill: "#292929"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M149.774 119.614L147.703 118.406V117.586L149.774 118.795V119.614Z",
    fill: "#292929"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M153.356 121.686L151.241 120.478V119.615L153.356 120.866V121.686Z",
    fill: "#292929"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.937 123.757L154.823 122.549V121.686L156.937 122.894V123.757Z",
    fill: "#292929"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 125.828L158.404 124.62V123.757L160.519 124.965V125.828Z",
    fill: "#292929"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0599 37.0684L67.4006 21.1028V78.1042L90.0544 91.1786L87.2497 94.3286H96.0523C96.7859 94.3286 97.3037 93.7677 97.3037 92.732V40.9519C97.3037 39.5279 96.3112 37.8019 95.0599 37.0684Z",
    fill: "url(#paint3_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3715 92.732C88.3715 94.156 87.3791 94.7169 86.1277 94.0265L24.2936 58.3414C23.0423 57.651 22.0498 55.8818 22.0498 54.4579V2.67772C22.0498 1.25377 23.0423 0.692814 24.2936 1.38322L86.1277 37.0684C87.3791 37.7588 88.3715 39.5279 88.3715 40.9519V92.732Z",
    fill: "url(#paint4_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1277 37.0684L24.2936 1.38322C23.0423 0.692814 22.0498 1.25377 22.0498 2.67772V5.18043L88.3715 43.4546V40.995C88.3715 39.5279 87.3359 37.8019 86.1277 37.0684Z",
    fill: "#C0162E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3367 2.93665L26.1058 3.97225V6.0003L24.3367 4.9647V2.93665Z",
    fill: "url(#paint5_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7888 4.92157L29.558 5.95717V7.98523L27.7888 6.94963V4.92157Z",
    fill: "url(#paint6_linear)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2407 6.90643L33.0099 7.94203V9.97009L31.2407 8.97764V6.90643Z",
    fill: "url(#paint7_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5126 58.7729L35.1243 58.5571V23.6487L35.5126 23.8644V58.7729Z",
    fill: "#292929"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1008 73.5303L60.7124 73.3145V51.912L61.1008 52.1278V73.5303Z",
    fill: "#292929"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4103 57.3921C57.8644 55.925 56.6562 53.7675 55.3617 51.4805C53.7652 48.6326 51.9097 45.3964 46.9043 42.5053C43.2365 40.3909 41.8989 37.241 40.6475 34.2636C39.4825 31.502 38.4037 28.8699 35.3401 27.1007C32.2333 25.2884 31.1114 27.7911 29.9032 30.3801C28.7381 32.8828 27.5731 35.515 24.4231 33.7027V32.8397C27.0553 34.3499 28.134 32.1061 29.2128 29.6897C30.3778 27.1007 31.7155 24.2096 35.3401 26.2809C38.7921 28.2658 40.0434 31.2863 41.2516 34.1773C42.4598 37.0684 43.6249 39.7868 46.8612 41.6854C52.2118 44.7491 54.2398 48.3306 55.8795 51.2216C57.174 53.5086 58.1665 55.2777 60.4534 56.5722C64.5096 58.8592 66.9691 56.3996 69.7739 53.5517C73.3553 49.884 77.4114 45.7847 85.9983 50.747V51.61C77.7998 46.8635 73.83 50.8764 70.378 54.4147C67.5732 57.2626 64.8979 59.9811 60.4534 57.4784C60.4534 57.3921 60.4103 57.3921 60.4103 57.3921Z",
    fill: "#C0162E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6724 15.0618V19.3768L34.3045 20.8871L35.3401 22.6563L36.3326 22.0521L38.9647 23.5624V19.2905L31.6724 15.0618Z",
    fill: "url(#paint8_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2603 43.3252V47.5971L59.8924 49.1073L60.8849 50.9196L61.9205 50.3155L64.5526 51.8258V47.5539L57.2603 43.3252Z",
    fill: "url(#paint9_linear)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8728 18.4276L36.7639 20.0673V20.6714L33.8728 19.0317V18.4276Z",
    fill: "url(#paint10_linear)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4609 46.5614L62.352 48.2011V48.8052L59.4609 47.1655V46.5614Z",
    fill: "url(#paint11_linear)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.177 57.2627L25.8037 55.8819V55.1052L28.177 56.486V57.2627Z",
    fill: "#292929"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5353 59.7654L30.1189 58.3846V57.6078L32.5353 58.9887V59.7654Z",
    fill: "#292929"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8503 62.2681L34.4771 60.8873V60.1106L36.8503 61.4914V62.2681Z",
    fill: "#292929"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2085 64.7708L38.8352 63.39V62.6133L41.2085 63.9941V64.7708Z",
    fill: "#292929"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5234 67.2735L43.1501 65.8927V65.116L45.5234 66.4968V67.2735Z",
    fill: "#292929"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8816 69.7762L47.5083 68.3954V67.6619L49.8816 68.9995V69.7762Z",
    fill: "#292929"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1965 72.2789L51.8232 70.8981V70.1646L54.1965 71.5022V72.2789Z",
    fill: "#292929"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5547 74.7816L56.1814 73.4008V72.6672L58.5547 74.0049V74.7816Z",
    fill: "#292929"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8696 77.2843L60.4963 75.9035V75.1699L62.8696 76.5076V77.2843Z",
    fill: "#292929"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M67.228 79.787L64.8547 78.4062V77.6727L67.228 79.0535V79.787Z",
    fill: "#292929"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5861 82.2897L69.1697 80.9089V80.1754L71.5861 81.5562V82.2897Z",
    fill: "#292929"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9011 84.7924L73.5278 83.4116V82.678L75.9011 84.0588V84.7924Z",
    fill: "#292929"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2592 87.2951L77.886 85.9143V85.1808L80.2592 86.5616V87.2951Z",
    fill: "#292929"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5742 89.7978L82.2009 88.417V87.6835L84.5742 89.0643V89.7978Z",
    fill: "#292929"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9832 35.9896L26.1491 0.304476C25.545 -0.0407252 24.984 -0.083876 24.5957 0.131875L22.7402 1.21063C23.1286 0.994877 23.6895 1.03803 24.2936 1.38323L86.1278 37.0684C87.3791 37.7588 88.3716 39.5279 88.3716 40.9519V92.732C88.3716 93.4224 88.1558 93.8971 87.7675 94.156L89.4935 93.1635C89.9681 92.9478 90.227 92.43 90.227 91.6533V39.8731C90.227 38.4492 89.1914 36.7232 87.9832 35.9896Z",
    fill: "#292929"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 169.041,
    y1: 14.7941,
    x2: 169.041,
    y2: 108.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 82.6488,
    y1: 79.0102,
    x2: 82.6488,
    y2: 174.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 116.952,
    y1: 106.291,
    x2: 97.7703,
    y2: 62.1242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 82.3522,
    y1: 21.1028,
    x2: 82.3522,
    y2: 94.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 55.2107,
    y1: 1.08881,
    x2: 55.2107,
    y2: 94.3209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 25.2212,
    y1: 2.93665,
    x2: 25.2212,
    y2: 6.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 28.6734,
    y1: 4.92157,
    x2: 28.6734,
    y2: 7.98523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 32.1253,
    y1: 6.90643,
    x2: 32.1253,
    y2: 9.97009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 38.9647,
    y1: 18.5909,
    x2: 28.817,
    y2: 26.6167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 64.5526,
    y1: 46.8542,
    x2: 54.4049,
    y2: 54.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 35.3183,
    y1: 18.4276,
    x2: 35.3183,
    y2: 20.6714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 60.9065,
    y1: 46.5614,
    x2: 60.9065,
    y2: 48.8052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPresentationPreview);
export default __webpack_public_path__ + "static/media/data_presentation_preview.c4ec661a34c880cb96e60fb9b64f4741.svg";
export { ForwardRef as ReactComponent };